var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5082_205679",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 104,
    height: 106
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 7H8V112.998H112V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5082_205679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7999 93.7962H79.574V71.5192C79.574 66.2075 79.4795 59.3673 72.1755 59.3673C64.8715 59.3673 63.6348 65.1555 63.6348 71.1327V93.7962H49.409V47.9883H63.0637V54.2489H63.257C66.0395 49.4869 71.218 46.6443 76.7314 46.8504C91.1505 46.8504 93.8085 56.3314 93.8085 68.6723V93.8005L93.7999 93.7962ZM33.3581 41.7277C28.798 41.7277 25.1009 38.0349 25.1009 33.4747C25.1009 28.9145 28.7937 25.2174 33.3538 25.2174C37.914 25.2174 41.6111 28.9102 41.6111 33.4704C41.6111 38.0306 37.9183 41.7277 33.3581 41.7277ZM40.4689 93.8005H26.2302V47.9883H40.4689V93.8005ZM100.889 12.0092H19.085C15.2162 11.962 12.0472 15.0622 12 18.9268V101.07C12.0472 104.939 15.2162 108.039 19.085 107.996H100.889C104.767 108.044 107.948 104.943 108 101.07V18.9225C107.948 15.045 104.762 11.9491 100.889 12.0006",
    fill: "#0A66C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9d14abbc77a84bd7cae46e0f7c5c6b45.svg";
export { ForwardRef as ReactComponent };